<script setup lang="ts">
defineProps<{
  eyebrow?: string
  title?: string
  ctaLabel?: string
  ctaHref?: string
  dark?: boolean
}>()
</script>

<template>
  <div class="flex items-end justify-between w-full border-b border-primary pb-4">
    <div class="flex flex-col gap-2 items-start">
      <p v-if="eyebrow" class="font-label font-light text-xs leading-4 tracking-wider text-brand">{{ eyebrow }}</p>
      <p v-if="title" :class="['font-serif font-normal text-2xl md:text-4xl leading-[44px]', dark ? 'text-white' : 'text-dark']">{{ title }}</p>
    </div>
    <NuxtLink v-if="ctaLabel" :to="ctaHref ?? '#'">
      <AppButton type="Ghost" size="Small" :label="ctaLabel" :showIconRight="true" />
    </NuxtLink>
  </div>
</template>
